import { render, staticRenderFns } from "./Document.vue?vue&type=template&id=0591533a&scoped=true"
import script from "./Document.vue?vue&type=script&lang=js"
export * from "./Document.vue?vue&type=script&lang=js"
import style0 from "./Document.vue?vue&type=style&index=0&id=0591533a&prod&lang=scss&scoped=true"
import style1 from "./Document.vue?vue&type=style&index=1&id=0591533a&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0591533a",
  null
  
)

export default component.exports